import { List } from 'immutable'
import setFilters from 'store/reducer-utils/setFilters'
import { updateObject } from 'utils/updateObject'
import {
  DROP_PAYMENTS,
  PAYMENTS_SET_FILTER,
  PAYMENTS_SET_LOADING,
  SET_PAYMENTS,
} from 'modules/Finance/PaymentProfiles/types'

const initialState = {
  loading: true,
  data: [],
  pagination: {
    offset: 0,
    limit: 50,
    total: 0,
  },
  filters: null,
}

const setUserPaymentProfilePayments = (state, { payload }) => {
  return updateObject(state, {
    ...payload,
    data: List(state.data).concat(List(payload.data)).toJS(),
    loading: false,
  })
}

const setProfilePaymentsFilter = (state, action) => {
  const filteredPayload = state?.filters
    ? [...action.payload].filter(
        (filter) => Object.keys(state.filters).indexOf(filter.fieldName) > -1,
      )
    : action.payload

  return setFilters(state, { ...action, payload: filteredPayload })
}

const setLoading = (state, { payload }) => {
  return updateObject(state, payload)
}

const dropUserPaymentProfilePayments = (state) => {
  return updateObject(state, {
    data: [],
    pagination: {
      offset: 0,
      limit: 50,
      total: 0,
    },
  })
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PAYMENTS:
      return setUserPaymentProfilePayments(state, action)
    case PAYMENTS_SET_FILTER:
      return setProfilePaymentsFilter(state, action)
    case PAYMENTS_SET_LOADING:
      return setLoading(state, action)
    case DROP_PAYMENTS:
      return dropUserPaymentProfilePayments(state)
    default:
      return state
  }
}

export default reducer
